<template>
  <v-btn
  style="position: absolute; bottom: 0; right: 0; margin: 20px 20px 40px 20px"
  color="wrld_red"
  dark
  id="optimization_date_picker"
  @click="picker.show()"
  >
  <span v-if="!isLoading">
    {{$t('uploads.optimization')}}
  </span>
  <v-progress-circular
    v-else
    size="20"
    width="3"
    indeterminate
    color="white"
  ></v-progress-circular>
  </v-btn>
</template>


<script>
  import { mapActions } from 'vuex'
  import 'litepicker/dist/css/style.css'
  import Litepicker from 'litepicker'
  import moment from 'moment-timezone'
  import appSync from '@/_services/appsync.service.js'
  import gql from 'graphql-tag'
  export default {
    name: 'OptimizationButton',
    data(){
      return {
        picker: null,
        isLoading: false
      }
    },
    mounted() {
      this.picker = new Litepicker({
        element: document.getElementById(`optimization_date_picker`),
        singleMode: true,
        lang: this.$i18n.locale,
        onSelect: (date) => (this.handlePickDate.apply(null, [date]))
      })
      this.picker.hide()
    },
    watch: {
    '$i18n.locale': {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (oldVal !== val && this.picker != null) {
          this.picker.setOptions({ lang: val })
        }
      }
    }
  },
    methods: {
      ...mapActions({
        showSnackbar: 'showSnackbar'
      }),
      async optimizeShipments ({ date }) {
          const OPTIMIZE_SHIPMENT = gql`mutation optimizeShipments($input: OptimizeShipmentsInput!) {
            optimizeShipments(input: $input) {
              taskID
            }
          }`
          try {
            const response = await appSync.mutate({
              mutation: OPTIMIZE_SHIPMENT,
              variables: {
                input: {
                  date,
                  // departure: moment(departureDate).format()
                }
              },
              fetchPolicy: 'no-cache'
            })
            return response.data.optimizeShipments
          } catch (error) {
            return Promise.reject(error)
          }
        },
      handlePickDate(date) {
        moment.tz.setDefault(moment.tz.guess())
        const presentDate = moment(date).utc(true).unix()
        const mutationDate = moment(date).utc(true).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        this.isLoading = true
        this.optimizeShipments({ date: mutationDate }).then(() => {
           this.showSnackbar({ message: `Optimization is running for: ${this.$options.filters.dateToReadable(presentDate, this.$i18n.locale)}`, color: 'success' })
        })
        .catch((error) => {
          this.showSnackbar({ message: this.$i18n.t('snackbars.error'), color: 'error' })
          console.error(error)
        })
        .finally(() => {
          this.isLoading = false
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
